import { PropsWithoutRef } from 'react'

import Icon from '@ant-design/icons'
import { IconBaseProps } from '@ant-design/icons/lib/components/Icon'

import { UploadErrorSvg } from './NeUploadErrorSvg'

export const NeUploadErrorIcon = (props: PropsWithoutRef<IconBaseProps>) => {
  return <Icon component={UploadErrorSvg} {...props} />
}
